import { Inline, Spacer } from 'vcc-ui';

import { ContentWrapper, H2 } from '@collab/atoms';
import { PageTitle } from '@collab/molecules';

import GenerateDemoAccessToken from 'features/test-access-tokens/GenerateDemoAccessToken';
import GenerateVolvoIdAccessToken from 'features/test-access-tokens/GenerateVolvoIdAccessToken';
import PageSeo from 'libs/seo/PageSeo';
import Markdown from 'molecules/Markdown';
import ContributeAside from 'organisms/ContributeAside/ContributeAside';
import { PageProps } from 'types/pages';

import useApiOptions from './useApiOptions';

const TestAccessTokensPage: React.FC<PageProps> = ({ content, pageMeta }) => {
  const { overview, demoCar, myVolvoCar } = content;
  const apiOptions = useApiOptions();

  return (
    <ContentWrapper>
      <PageSeo
        title={pageMeta.title}
        category={pageMeta.category}
        description={pageMeta.seo.description}
      />
      <PageTitle title={pageMeta.title} category={pageMeta.category} />
      <H2>{overview.heading}</H2>
      <Markdown>{overview.body}</Markdown>
      <H2>{demoCar.heading}</H2>
      <Markdown>{demoCar.body}</Markdown>
      <Spacer size={4} />
      <GenerateDemoAccessToken
        apiOptions={apiOptions}
        authProtectedConfig={accessTokenAuthProtectedConfig}
      />
      <Inline id={authorizeMyCarId} />
      <H2>{myVolvoCar.heading}</H2>
      <Markdown>{myVolvoCar.body}</Markdown>
      <Spacer size={4} />
      <GenerateVolvoIdAccessToken
        apiOptions={apiOptions}
        scrollId={authorizeMyCarId}
        authProtectedConfig={accessTokenAuthProtectedConfig}
      />
      <ContributeAside repoUrl={pageMeta.repoUrl} />
    </ContentWrapper>
  );
};

const authorizeMyCarId = 'authorizeMyCar';

const accessTokenAuthProtectedConfig = {
  redirectUrl: '/apis/docs/test-access-tokens',
  description: 'To generate an access token you need to be signed in.',
};

export default TestAccessTokensPage;
